<div
  class="user-settings-drawer"
  (click)="$event.stopPropagation()"
  data-e2e="user-drawer-fragment"
>
  <ng-container>
    <user-settings-drawer-details
      (closeUserSettingsDrawer)="closeUserSettingsDrawer.emit()"
    ></user-settings-drawer-details>
  </ng-container>
</div>
